import React from 'react';
import TreeMenu from '../../common/TreeMenu';
import usePermission from '../../../hooks/usePermission';

function ElectronicBook() {
  const dataTree = [
    {
      id: 'BOOK',
      title: 'Sách điện tử',
      url: '/electronic-book/book',
    },
    {
      id: 'ACTIVE_CODE',
      title: 'Mã kích hoạt',
      url: '/electronic-book/active-code',
    },
  ];

  usePermission(['ROLE_ADMIN']);

  return <TreeMenu dataTree={dataTree} />;
}

export default ElectronicBook;
